import { z } from 'zod';

export const skillsSynchronizationModeSchema = z.enum(['PERMISSIVE', 'RESTRICTED']);

export type SkillsSynchronizationMode = z.infer<typeof skillsSynchronizationModeSchema>;

export const terminologyTranslationSchema = z.object({
    language: z.string(),
    many: z.string(),
    one: z.string(),
});

export type TerminologyTranslation = z.infer<typeof terminologyTranslationSchema>;

export const jobArchitectureTerminologySchema = z.object({
    jobClusters: terminologyTranslationSchema.array().optional(),
    jobFamilies: terminologyTranslationSchema.array().optional(),
    jobLevels: terminologyTranslationSchema.array().optional(),
    jobRoles: terminologyTranslationSchema.array().optional(),
});

export type JobArchitectureTerminology = z.infer<typeof jobArchitectureTerminologySchema>;

export const skillProficiencyLevelTerminologySchema = z.object({
    advanced: terminologyTranslationSchema.array().optional(),
    basic: terminologyTranslationSchema.array().nullable(),
    domainExpert: terminologyTranslationSchema.array().optional(),
    professional: terminologyTranslationSchema.array().optional(),
    qualified: terminologyTranslationSchema.array().optional(),
});

export type SkillProficiencyLevelTerminology = z.infer<typeof skillProficiencyLevelTerminologySchema>;

export const companySettingsSchema = z.object({
    jobArchitectureTerminology: jobArchitectureTerminologySchema.optional(),
    skillProficiencyLevelTerminology: skillProficiencyLevelTerminologySchema.optional(),
    skillsSynchronizationMode: skillsSynchronizationModeSchema,
    warningSignalsVisible: z.boolean(),
});

export type CompanySettings = z.infer<typeof companySettingsSchema>;

export const companySettingsUpdateSchema = z.object({
    jobArchitectureTerminology: jobArchitectureTerminologySchema.optional(),
    skillProficiencyLevelTerminology: skillProficiencyLevelTerminologySchema.optional(),
    skillsSynchronizationMode: skillsSynchronizationModeSchema.optional(),
    warningSignalsVisible: z.boolean().optional(),
});

export type CompanySettingsUpdate = z.infer<typeof companySettingsUpdateSchema>;
